import { IUser } from "~/types/types";

export default function convertUserTypenameToAuthor(user: IUser): string {
  if (user.__typename === "GovernmentUser") {
    return "GovernmentUser";
  } else if (user.__typename === "VendorUser") {
    return "VendorUser";
  } else if (["GovernmentUser", "VendorUser"].includes(user.__typename)) {
    return user.__typename;
  } else {
    return "PendingUser";
  }
}
